import { Button, Input, Modal, Typography, Form } from "antd";
import React, { useState } from "react";
import { openNotification } from "../../../../../Components/Notification";
import organizationService from "../../../../../Service/organization.service";

interface SaveGSTModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onProceed: () => void;
}

const SaveGSTModal: React.FC<SaveGSTModalProps> = ({
  open,
  setOpen,
  onProceed,
}) => {
  const [gstNumber, setGstNumber] = useState("");
  const [form] = Form.useForm();

  const gstRegex =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;

  const handleSave = async () => {
    try {
      await form.validateFields();
      const response = await organizationService.editOrganization({
        gst: gstNumber,
      });
      if (response) {
        setOpen(false);
        openNotification(
          "success",
          "GST number saved successfully",
          "You can now proceed with your purchase",
        );
        onProceed();
      }
    } catch (error) {
      console.error("Error saving GST number: ", error);
    }
  };

  return (
    <Modal
      afterClose={() => {
        form.resetFields();
      }}
      className="gst-modal"
      title={"GST Number Is Missing"}
      centered
      open={open}
      closable={false}
      maskClosable={false}
      footer={null}
    >
      <div className="gst-number-modal-content-wrapper">
        <Typography.Text>
          If you would like to get input tax credit for this purchase, please
          provide the GST number of your company
        </Typography.Text>
        <Form form={form} layout="vertical">
          <Form.Item
            name="gstNumber"
            validateTrigger="onSubmit"
            rules={[
              {
                required: true,
                message: "GST number is required.",
              },
              {
                pattern: gstRegex,
                message: "Please enter a valid GST number.",
              },
            ]}
            style={{ margin: 0 }}
          >
            <Input
              placeholder="Enter GST Number"
              value={gstNumber}
              onChange={(e) => setGstNumber(e.target.value)}
            />
          </Form.Item>
        </Form>

        <div className="gst-number-modal-footer-wrapper">
          <Button
            size="middle"
            type="default"
            onClick={() => {
              setOpen(false);
              onProceed();
            }}
          >
            Do it Later
          </Button>
          <Button size="middle" type="primary" onClick={handleSave}>
            Save GST
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SaveGSTModal;
